import { useEffect } from 'react';
import { useFormik } from 'formik';
import { PqrFinalCausality } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrFinalCausality = (finalCausality?: PqrFinalCausality) => {
    const formik = useFormik({
        initialValues: {
            protection: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            protection: useGetNameOrValue(finalCausality?.protection || ''),
        });
    }, [finalCausality]);

    return {
        formik,
    };
};
